<form [formGroup]="form" (ngSubmit)="formSubmit()">
    <div class="d-flex justify-content-between align-items-center my-2">
      <div class="d-flex align-items-center">
        <div class="card-sub-heading ml-3 bold">Add Low Activity Reason</div>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" type="button">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
      </button>
    </div>
    <div class="mt-3">
      <input
        type="text"
        class="form-control w-100"
        placeholder="Low activity reason"
        formControlName="title"
      />
      <app-error-message
        [formName]="form"
        [fieldName]="'title'"
        [type]="'group'"
      >
      </app-error-message>
    </div>
    <div class="d-flex mt-4">
      <div class="col-md-12 d-flex justify-content-center">
        <button
          class="custom-btn w-100"
          (click)="dialogRef.close()"
          type="button"
        >
          Cancel
        </button>
        <button class="custom-btn w-100" type="submit">
          Add
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
  